import { useEffect, useState } from "react";
import BackgroundCanvas, { pallete2 } from "./Background";

console.log(pallete2);

const Container = (props) => {
  return (
    <div className="fullscreen-view" style={{ height: "100%" }}>
      <div
        className={props.class}
        style={{
          background: "rgba(0, 0, 0, 0)",
          color: "white",
          maxWidth: "500px",
          position: "relative",
          ...(!isMobileDevice()
            ? { top: "50%", transform: "translateY(50%)", margin: "auto" }
            : { top: "50vh", marginBottom: "20vh"}),
        }}
      >
        <BackgroundCanvas></BackgroundCanvas>
        <div
          className="header"
          style={{
            color: "white",
            background: "rgba(0, 0, 0, 0.5)",
          }}
        >
          Teinin huone
        </div>
        {props.children}
      </div>

      <div style={{ height: "30vh" }}></div>
    </div>
  );
};

function isMobileDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    "mobile",
    "android",
    "iphone",
    "ipad",
    "ipod",
    "blackberry",
    "windows phone",
  ];

  return mobileKeywords.some((keyword) => userAgent.includes(keyword));
}

const FrontPage = ({ aloitaButtonPress, progress, loadUnity }) => {
  const [backimage, setBackImage] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    function calculateVh() {
      var vh = window.screen.height * 0.01;
      document.documentElement.style.setProperty("--vh", vh + "px");
    }

    const handleResize = () => {
      setBackImage(
        isMobileDevice() || window.innerWidth < 900
          ? "https://images.cdn.yle.fi/image/upload/w_720,h_1080,x_492,y_0,q_auto:eco,f_auto,fl_lossy,c_crop/w_720,h_1080,dpr_1/39-113820664a5267aef6c6"
          : "https://images.cdn.yle.fi/image/upload/w_1920,h_1080,x_0,y_0,q_auto:eco,f_auto,fl_lossy,c_crop/w_1920,h_1080,dpr_1/39-113820664a5267aef6c6"
          );
      // Initial calculation
      calculateVh();
    };

    // Add the event listener for window resize
    window.addEventListener("resize", handleResize);

    handleResize();
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array to run the effect only once on component mount

  return (
    <div
      style={{ position: "relative", minHeight: loadUnity ? "95vh" : "100vh" }}
      class="frontpage-content"
    >
      <div
        style={{
          width: "100%",
          position: "fixed",
          height: "100vh",
          backgroundImage: "url(" + backimage + ")",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        }}
      ></div>
      {/*       <img
        src={backimage}
        style={{ width: "100%", position: "fixed", height: "calc(100*var(--vh))" }}
      /> */}
      {loading && (
        <div className="loading-text">
          <div class="loading-text-text">Ladataan...</div>
          <div class="loading-text-number">{progress}%</div>
        </div>
      )}
      {!loading && (
        <Container class={"end-view-container"} headerText={"Jesss!"}>
          <div class="start-teksti">
            <p>
              Vuosituhat on vaihtunut. Olet teini, jolle vain taivas on rajana -
              jos ei lasketa saldorajaa tai tuskastuttavan hidasta
              nettiyhteyttä.
            </p>
            <p>
              Pärjäätkö ulkonäköpaineiden ja teini-idolien maailmassa? Tehtäväsi
              on päästä parhaan ystäväsi syntymäpäiväbileisiin ehjänä. Kokeile,
              selviätkö haasteista aidolla nollariotteella, vai kompastutko
              milleniumin käänteisiin.
            </p>
          </div>
          <button
            className="aloita-nappi"
            onClick={() => {
              window.setTimeout(() => {
                setLoading(true);
                if (typeof aloitaButtonPress === "function") {
                  aloitaButtonPress();
                }
              }, 0);
            }}
          >
            Aloita
          </button>
        </Container>
      )}
    </div>
  );
};

export default FrontPage;
